module.exports = __webpack_public_path__ + "img/Hawaiian_Poke_Tofu.cabb2327.jpg";